const formValidation = require('../components/formValidation');
const scrollAnimate = require('../components/scrollAnimate');

function successMessage($form, message) {
    $form.addClass(window.styleConstants.hideClass);
    $('.js-success-container').removeClass(window.styleConstants.hideClass);
    $('.js-success-message').html(message);

    scrollAnimate($('.js-success-container'));
}

$('.js-confirm-contact-us').on('submit', (e) => {
    const button = $('.js-confirm-contactus-button');
    const url = button.data('href');
    const $form = $(e.target);

    e.preventDefault();

    $form.spinner().start();

    $.ajax({
        url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: (data) => {
            $form.spinner().stop();
            if (!data.success) {
                formValidation($form, data);
            } else {
                successMessage($form, data.msg);
            }
        },
        error: (err) => {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
            $form.spinner().stop();
        }
    });
});
